import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { TokenService } from '../../../app/token.service';
;
import { Injectable } from '@angular/core';
import { MainService } from './main.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {



  
  httpUrl;


  constructor(private http: HttpClient, private main: MainService ,private token:TokenService) {
    this.httpUrl = this.main.httpUrl + "/hr/setting";
  }
  //fields
  async getFields(obj:any) {

    const res = await this.http.get<any>(this.main.httpUrl + '/metadata/fields/getfields' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;

    });
    return res;

  }
  async createFields(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/metadata/fields/createField', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateFields(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/metadata/fields/updateField', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  //codeValue
  async getCodeValue(b_acct_id:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/codeValue/getCodeValues' + b_acct_id,{ headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getFieldCodeValues(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/metadata/codeValue/getFieldCodeValues' + JSON.stringify(obj) , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async insertCodeValue(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/metadata/codeValue/createCodeValue', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async updateCodeValues(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/metadata/codeValue/updateCodeValue', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteCodeValue(obj:any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/metadata/codeValue/deleteCodeValue' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  // *******************************************section map service***************//

  async sectionMap(obj:any) {
    const resp:any = await this.http.post<any>(this.main.httpUrl + '/icms/inspection/sectionMap', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getSectionMap(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/inspection/getSectionMap' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async deleteSectionMap(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/icms/inspection/deleteSectionMap', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  /***************************************************Recovery Calculation****************************************** */

  async getOrderDataOnCaseID(obj:any) {
    let resp = await this.http.post<any>(this.main.httpUrl + '/icms/court-order/getOrderDataOnCaseID', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }

  async insertRecoveryCalculationData(obj:any) {
    let resp = await this.http.post<any>(this.main.httpUrl + '/icms/court-order/insertRecoveryData', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }


  async getDocumentDetails(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/court-order/getDocumentDetails' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  /***************************************************************Support Department Screen start****************************/

  async createDepartment(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/icms/support-department/createDepartment', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }
  async getDepartmentData(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/support-department/getDepartment' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async delete(obj:any) {
    const resp = await this.http.delete<any>(this.main.httpUrl + '/icms/support-department/deleteDepartment' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateDepartment(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/icms/support-department/updateDepartment', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }


  /**********************************************************Support letter Screen start *************************************/
  async getOfficerName(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/support-department/getOfficerName' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getZoneWiseUser(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/icms/support-department/getZoneUser', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getSupportLetter(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/support-department/getSupportLetter' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }



  async createSupportLetter(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/icms/support-department/createSuppletter', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateSupportLetter(obj:any) {
    const resp = await this.http.put<any>(this.main.httpUrl + '/icms/support-department/updateSupportLetter', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  /**********************************************************Support letter Screen end *************************************/
  // court order screen start

  async getOrderData(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/court-order/getOrderData' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCourtData(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/court-order/getCourtData' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getExecutionData(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/court-order/getExecutionData' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async downloadexecutionImage(obj:any) {
    const resp = await this.http.post(this.main.httpUrl + '/icms/court-order/downloadexecutionImage', obj, { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async viewDefendentImage(obj:any) {
    const resp = await this.http.post(this.main.httpUrl + '/icms/court-order/viewDefendentImage', obj, { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    }
    return
  }

  async submitReportSub(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/icms/upload/uploadReport', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async forwordFile(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/icms/court-order/forwordFile', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getAttachedDocumnet(obj:any) {
    const resp = await this.http.post(this.main.httpUrl + '/icms/court-order/getAttachedDoc', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }



  async downloadDocument(obj:any) {
    const resp = await this.http.post(this.main.httpUrl + '/icms/court-order/downloadDocument', obj, { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) , responseType: 'blob' }).toPromise().then(res => {
      return res;
    });
    if (resp) {
      return resp;
    } return
  }


  async defendentDocList(obj:any) {
    const resp = await this.http.post(this.main.httpUrl + '/icms/court-order/defendentDocList', obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }
  // court order screen end
  // Assigned Order screen start

  async getAssignedOrder(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/court-order/getAssignedOrder' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  // Assigned order component end

  //Notification task


  async getPendingTask(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/icms/task/getPendingTask' + obj , { headers: new HttpHeaders().append('token',this.token.token).append('session', this.token.session) }).toPromise().then(res => {
      return res;
    })
    return resp;
  }
}
